
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // For translations
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

// Import the icons from the local assets folder
import highlightsIcon from '../assets/icons/highlights.svg';
import landIcon from '../assets/icons/land.svg';
import buildingIcon from '../assets/icons/building.svg';
import landParcelsIcon from '../assets/icons/land2.svg';
import utilitiesIcon from '../assets/icons/utilities.svg';
import elevationIcon from '../assets/icons/elevation.svg';
import geologyIcon from '../assets/icons/geology.svg';
import sansrsIcon from '../assets/icons/sansrs.svg';
import waterIcon from '../assets/icons/water.svg';
import geoNamesIcon from '../assets/icons/geo-name.svg';
import landUseIcon from '../assets/icons/land-use.svg';
import nationalAddressIcon from '../assets/icons/address.svg';
import imageryIcon from '../assets/icons/imagery.svg';
import transportIcon from '../assets/icons/transport.svg';
import populationIcon from '../assets/icons/population.svg';

function NationalGeocatalog() {
  /* const { t } = useTranslation(); // Hook for translation
  const [isModalOpen, setModalOpen] = useState(false);
  const [pendingLink, setPendingLink] = useState(null);

  // Check localStorage for policy acceptance status
  useEffect(() => {
    const policyAccepted = localStorage.getItem('policyAccepted');
    if (!policyAccepted) {
      setModalOpen(true); // Show modal if policy is not accepted
    }
  }, []);

  const openModal = (link) => {
    const policyAccepted = localStorage.getItem('policyAccepted');
    if (policyAccepted) {
      window.open(link, '_blank'); // Open link directly if policy was accepted
    } else {
      setPendingLink(link); // Store the link that the user wants to open
      setModalOpen(true); // Open the modal
    }
  };

  const handleAccept = () => {
    localStorage.setItem('policyAccepted', 'true'); // Store policy acceptance in localStorage
    setModalOpen(false);
    if (pendingLink) {
      window.open(pendingLink, '_blank'); // Open the stored link in a new tab
    }
  };

  const handleDecline = () => {
    setModalOpen(false);
  }; */
  const { t } = useTranslation(); // Hook for translation

  const [isModalOpen, setModalOpen] = useState(false);
  const [pendingLink, setPendingLink] = useState(null);

  // Function to handle link click and check for policy acceptance
  const openModal = (link) => {
    const policyAccepted = localStorage.getItem('policyAccepted');
    if (policyAccepted) {
      // If policy is accepted, directly open the link in a new tab
      window.open(link, '_blank');
    } else {
      // Otherwise, show the modal to accept the policy
      setPendingLink(link); // Store the link that the user wants to open
      setModalOpen(true); // Open the modal
    }
  };

  const handleAccept = () => {
    localStorage.setItem('policyAccepted', 'true'); // Store policy acceptance in localStorage
    setModalOpen(false); // Close the modal
    if (pendingLink) {
      window.open(pendingLink, '_blank'); // Open the stored link in a new tab after accepting the policy
    }
  };

  const handleDecline = () => {
    setModalOpen(false); // Close the modal, do not open the link
  };

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, rgba(3, 52, 68, 1) 0%, rgba(3, 52, 68, 0.9) 50%, rgba(3, 52, 68, 1) 100%)',
      }}
    >
      <div className="space" style={{ height: '100px' }}></div>

      <h2 className="text-center mb-5" style={{ color: '#fff' }}>
        {t('geocatalog')}
      </h2>

      <h4 className="text-center mb-5" style={{ color: '#fff', fontSize: '1.2rem', marginLeft: '5rem', marginRight: '5rem' }}>
        {t('geocatalog_section1')}
      </h4>
      <h4 className="text-center mb-5" style={{ color: '#fff', fontSize: '1.2rem', marginLeft: '5rem', marginRight: '5rem' }}>
        {t('geocatalog_section2')}
      </h4>

      <section className="our-industry">
        <h2>{t('our_industry')}</h2>

        <div className="industry-grid">
          <div className="industry-item">
          <img
              src={highlightsIcon}
              alt="Admin Regions"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Administrative%20Regions%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('admin_region')}</p>
          </div>

          <div className="industry-item">
          <img
              src={landIcon}
              alt="Land Cover"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Land%20cover%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('land_cover')}</p>
          </div>

            

          <div className="industry-item">
          <img
              src={buildingIcon}
              alt="Buildings"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Buildings%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('buildings')}</p>
          </div>


          <div className="industry-item">
          <img
              src={landParcelsIcon}
              alt="Land Parcels"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Land%20Parcels%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('land_parcels')}</p>
          </div>

            

          <div className="industry-item">
            <img src={utilitiesIcon} alt="Utilities" />
            <p>{t('utilities')}</p>
          </div>

          <div className="industry-item">
            <img src={elevationIcon} alt="Elevation" />
            <p>{t('elevation')}</p>
          </div>

          <div className="industry-item">
          <img
              src={geologyIcon}
              alt="Geology"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Geology%22:true%7D%7D')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('geology')}</p>
          </div>

           

          <div className="industry-item">
          <img
              src={sansrsIcon}
              alt="SANSRS"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22SANSRS%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('sansrs')}</p>
          </div>



          <div className="industry-item">
          <img
              src={waterIcon}
              alt="Water"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Water%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('water')}</p>
          </div>


            

          <div className="industry-item">
          <img
              src={geoNamesIcon}
              alt="Geographical Names"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Geographical%20names%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('geographical_names')}</p>
          </div>


          <div className="industry-item">
          <img
              src={landUseIcon}
              alt="Land Use"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Land%20use%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('land_use')}</p>
          </div>

            
          <div className="industry-item">
          <img
              src={nationalAddressIcon}
              alt="National Address"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22National%20Address%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('national_address')}</p>
          </div>

          <div className="industry-item">
            <img src={imageryIcon} alt="Imagery" />
            <p>{t('imagery')}</p>
          </div>

          <div className="industry-item">
          <img
              src={transportIcon}
              alt="Transport"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Transport%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('transport')}</p>
          </div>


          <div className="industry-item">
          <img
              src={populationIcon}
              alt="Population Distribution"
              onClick={() => openModal('https://geocatalog.geoportal.sa/geonetwork/srv/eng/catalog.search#/search?query_string=%7B%22tag.%5C%5C*%22:%7B%22Population%20distribution%22:true%7D%7D&from=1&to=30')}
              style={{ cursor: 'pointer' }} // Make it clear the image is clickable
            />
            <p>{t('population_distribution')}</p>
          </div>

        </div>
      </section>

  
   {/* Modal */}
   {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '10px' }}>
            {t('popup_title')}
            </h3>
            <hr></hr>
            <div style={{ padding: '10px', textAlign: 'justify', lineHeight: '1.6', fontSize: '16px' }}>
              <h4 style={{ textAlign: 'center', fontWeight: 'bold' }}>{t('popup_subtitle')}</h4>
              <br></br>
              <p>{t('popup_par1')}
              </p>
              <p>{t('popup_par2')}
              </p>
              <p style={{ textAlign: 'justify' }}> <Link to="/national-geocatalog/Agreement" target='_blank'>{t('usage_agreement')}</Link></p>

            </div>
            <hr></hr>
            <div className="modal-buttons" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}>
              <button onClick={handleDecline} style={{ padding: '10px 20px', backgroundColor: '#ddd', cursor: 'pointer' }}>
                Decline
              </button>
              <button onClick={handleAccept} style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', cursor: 'pointer' }}>
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default NationalGeocatalog;
   {/* {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '10px' }}>
              سياسات الإستخدام والخصوصية للمنصة الجيومكانية
            </h3>
            <div style={{ padding: '10px', textAlign: 'justify', lineHeight: '1.6', fontSize: '16px' }}>
              <h4 style={{ textAlign: 'center', fontWeight: 'bold' }}>استخدام المنصة الجيومكانية الوطنية</h4>
              <p>
                هذه المنصة الإلكترونية للهيئة العامة للمساحة والمعلومات الجيومكانية بالمملكة العربية السعودية
                (التي يُشار إليها هنا بعبارة "المنصة الجيومكانية الوطنية" أو "المنصة") تتيح استخدامك الشخصي،
                ويخضع دخولك واستخدامك لهذه المنصة لبنود وشروط الاستخدام هذه، وأنظمة المملكة العربية السعودية
                ومن بينها على سبيل المثال لا الحصر التعاملات الإلكترونية ونظام مكافحة الجرائم المعلوماتية.
                وبعد موافقتك ودخولك إلى المنصة، فإن موافقة تامة على شروط هذه الاتفاقية.
              </p>
              <p>
                يجوز للهيئة، بدون إشعار لاحق، تغيير هذه البنود والشروط، ويمثل استمرارك في استخدام المنصة بعد
                إدخال هذه التعديلات قبولاً لبنود هذه الاتفاقية كما تم تعديلها.
              </p>
            </div>
            <div className="modal-buttons" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}>
              <button onClick={handleDecline} style={{ padding: '10px 20px', backgroundColor: '#ddd', cursor: 'pointer' }}>
                Decline
              </button>
              <button onClick={handleAccept} style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', cursor: 'pointer' }}>
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default NationalGeocatalog; */}